import {defineMessages} from 'react-intl';

const messages = defineMessages({
  mediaNotInserted: {
    id: 'mediaNotInserted',
    defaultMessage: 'Media not inserted'
  },
  noFeedback: {
    id: 'noFeedback',
    defaultMessage: 'No feedback text'
  },
  somethingWentWrong: {
    id: 'dispatch.somethingWentWrong',
    defaultMessage: 'Failed to submit dispatch request. Contact your administrator.'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  describeIssue: {
    id: 'describeIssue',
    defaultMessage: 'Describe the issue you are experiencing'
  },
  fileNotSupported: {
    id: 'fileNotSupported',
    defaultMessage: 'The file could not be uploaded because the file format is not supported.'
  },
  delete: {
    id: 'common.actions.delete',
    defaultMessage: 'Delete'
  },
  createDispatchDescription: {
    id: 'createDispatchDescription',
    defaultMessage: 'You are able to alert the system about an issue.'
  },
  submitDispatch: {
    id: 'dispatch.submitDispatch',
    defaultMessage: 'Submit Dispatch'
  },
  createDispatchTitle: {
    id: 'dispatch.createDispatchTitle',
    defaultMessage: 'Create Dispatch'
  },
  productionLine: {
    id: 'productionLine',
    defaultMessage: 'Production Line'
  },
  selectLine: {
    id: 'selectLine',
    defaultMessage: 'Select Line'
  },
  dispatchType: {
    id: 'dispatchType',
    defaultMessage: 'Dispatch Type'
  },
  selectDispatchType: {
    id: 'selectDispatchType',
    defaultMessage: 'Select Dispatch Type'
  },
  dispatchMachine: {
    id: 'dispatchMachine',
    defaultMessage: 'Machine'
  },
  selectDispatchMachine: {
    id: 'selectDispatchMachine',
    defaultMessage: 'Select Machine'
  },
  details: {
    id: 'details',
    defaultMessage: 'Details'
  },
  dispatchSubmitted: {
    id: 'dispatch.dispatchSubmitted',
    defaultMessage: 'Submitted dispatch report.'
  },
  selectLineFirst: {
    id: 'dispatch.selectLineFirst',
    defaultMessage: 'Must select a production line first.'
  }
});

export default messages;
